import { render, staticRenderFns } from "./ShiftDetail.vue?vue&type=template&id=74a5b92d"
import script from "./ShiftDetail.vue?vue&type=script&lang=js"
export * from "./ShiftDetail.vue?vue&type=script&lang=js"
import style0 from "./ShiftDetail.vue?vue&type=style&index=0&id=74a5b92d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports